module.exports = __webpack_public_path__ + "img/Shock absorber.b4fb2805.png";